// Spark / includes/spotlight - обвязка спонсорских блоков (эталон ads.html).
// Слайдер (billboard/hero: доты, автоплей по data-autoplay, драг-свайп),
// карусели (azrow: стандартные карточки со скроллом, crow: статейные spotc),
// тултип-дисклоужер у иконок "i". Классы ТОЛЬКО spotlight-*.
// Потребители: index.js (главная); single.js пересядет отдельным проходом
// (его локальная azrow-обвязка пока живёт своей копией).

// слайдер: один слайд во вьюпорте, translateX-трек
export function initSpotlightSliders( root ) {

    ( root || document ).querySelectorAll('.spotlight-slider').forEach( ( sl ) => {

        if( sl.__spotInit )
            return;

        sl.__spotInit = true;

        const track = sl.querySelector('.spotlight-slider-track');

        if( ! track )
            return;

        const slides   = Array.from( track.children );
        const count    = slides.length;
        const dots     = Array.from( sl.querySelectorAll('.spotlight-slider-dots .dot') );
        const autoplay = parseInt( sl.getAttribute('data-autoplay') || '0', 10 );

        let idx   = 0;   // зафиксированный слайд
        let shown = 0;   // подсвеченный: на драге может опережать idx
        let timer = null;

        function norm( i ) {
            return ( ( i % count ) + count ) % count;
        }

        // видимость слайда (opacity в core/_spotlight) и активная точка
        function paint( i ) {
            shown = i;
            slides.forEach( ( s, n ) => {
                s.classList.toggle( 'active', n === i );
            } );
            dots.forEach( ( d, n ) => {
                d.classList.toggle( 'active', n === i );
            } );
        }

        function render() {
            track.style.transform = 'translateX(-' + ( idx * 100 ) + '%)';
            paint( idx );
        }

        function go( i ) {
            idx = norm( i );
            render();
        }

        function stop() {
            if( timer ) {
                clearInterval( timer );
                timer = null;
            }
        }

        function play() {
            stop();
            if( autoplay && count > 1 )
                timer = setInterval( () => { go( idx + 1 ); }, autoplay );
        }

        const arrowL = sl.querySelector('.spotlight-slider-arrow.l');
        const arrowR = sl.querySelector('.spotlight-slider-arrow.r');

        if( arrowL )
            arrowL.addEventListener( 'click', () => { go( idx - 1 ); play(); } );

        if( arrowR )
            arrowR.addEventListener( 'click', () => { go( idx + 1 ); play(); } );

        dots.forEach( ( d, i ) => {
            d.addEventListener( 'click', () => { go( i ); play(); } );
        } );

        // драг-свайп: тянем трек пикселями. Порог - 30% ширины вьюпорта:
        // до него активным остаётся текущий слайд, за ним подсветка
        // (и точка) переходят на соседний прямо в процессе протяжки.
        // Вернули палец назад - подсветка возвращается тоже.
        const THRESHOLD = .3;

        let startX   = 0;
        let deltaX   = 0;
        let dragW    = 0;
        let dragging = false;

        function dragStart( x ) {
            dragging = true;
            startX   = x;
            deltaX   = 0;
            dragW    = track.offsetWidth;
            track.style.transition = 'none';
            stop();
        }

        function dragMove( x ) {
            if( ! dragging )
                return;

            deltaX = x - startX;
            track.style.transform = 'translateX(calc(-' + ( idx * 100 ) + '% + ' + deltaX + 'px))';

            const crossed = dragW > 0 && Math.abs( deltaX ) / dragW >= THRESHOLD;
            const target  = crossed ? norm( idx + ( deltaX < 0 ? 1 : -1 ) ) : idx;

            if( target !== shown )
                paint( target );
        }

        function dragEnd() {
            if( ! dragging )
                return;

            dragging = false;
            track.style.transition = '';

            // подсветка на драге уже ушла на соседний - его и фиксируем
            if( shown !== idx )
                go( shown );
            else
                render();

            play();
        }

        sl.addEventListener( 'mousedown', ( e ) => {
            if( e.target.closest('a,button') )
                return;
            e.preventDefault();
            dragStart( e.pageX );
        } );

        document.addEventListener( 'mousemove', ( e ) => { dragMove( e.pageX ); } );
        document.addEventListener( 'mouseup', dragEnd );

        sl.addEventListener( 'touchstart', ( e ) => { dragStart( e.touches[0].pageX ); }, { passive : true } );
        sl.addEventListener( 'touchmove', ( e ) => { dragMove( e.touches[0].pageX ); }, { passive : true } );
        sl.addEventListener( 'touchend', dragEnd );

        render();
        play();
    } );
}

// карусели: azrow (стандартные карточки/duo, скролл трека),
// crow (статейные spotc, стрелки в полях)
export function initSpotlightCarousels( root ) {

    ( root || document ).querySelectorAll('.spotlight-azrow').forEach( ( wrap ) => {

        if( wrap.__spotInit )
            return;

        wrap.__spotInit = true;

        const track = wrap.querySelector('.spotlight-row, .spotlight-duo');

        if( ! track )
            return;

        const arrowL = wrap.querySelector('.spotlight-slider-arrow.l');
        const arrowR = wrap.querySelector('.spotlight-slider-arrow.r');

        function step() {
            const card = wrap.querySelector('.spotlight-card, .spotlight-duo-card');
            if( ! card )
                return 280;
            const w = card.getBoundingClientRect().width + 16;
            return wrap.querySelector('.spotlight-duo')
                ? w
                : w * 2;
        }

        // стрелки нужны только когда трек реально переполнен
        function update() {
            const overflow = track.scrollWidth > track.clientWidth + 4;
            if( arrowL )
                arrowL.style.display = overflow
                    ? ''
                    : 'none';
            if( arrowR )
                arrowR.style.display = overflow
                    ? ''
                    : 'none';
        }

        if( arrowL )
            arrowL.addEventListener( 'click', () => {
                track.scrollBy( { left : -step(), behavior : 'smooth' } );
            } );

        if( arrowR )
            arrowR.addEventListener( 'click', () => {
                track.scrollBy( { left : step(), behavior : 'smooth' } );
            } );

        update();
        window.addEventListener( 'resize', update );
    } );

    ( root || document ).querySelectorAll('.spotlight-crow').forEach( ( wrap ) => {

        if( wrap.__spotInit )
            return;

        wrap.__spotInit = true;

        const vp = wrap.querySelector('.spotlight-crow-vp');

        if( ! vp )
            return;

        function step() {
            const card = wrap.querySelector('.spotlight-spotc');
            return card
                ? card.getBoundingClientRect().width + 20
                : 300;
        }

        const arrowL = wrap.querySelector('.spotlight-slider-arrow.l');
        const arrowR = wrap.querySelector('.spotlight-slider-arrow.r');

        if( arrowL )
            arrowL.addEventListener( 'click', () => {
                vp.scrollBy( { left : -step(), behavior : 'smooth' } );
            } );

        if( arrowR )
            arrowR.addEventListener( 'click', () => {
                vp.scrollBy( { left : step(), behavior : 'smooth' } );
            } );
    } );
}

// тултип-дисклоужер: один fixed-элемент на документ, делегирование hover
export function initSpotlightTips() {

    if( window.__spotTip )
        return;

    const tip = document.createElement('div');
    tip.className   = 'spotlight-tip';
    tip.textContent = 'Sponsored \u2014 you\u2019re seeing this because it may be relevant to what you\u2019re browsing.';
    document.body.appendChild( tip );
    window.__spotTip = tip;

    function show( el ) {
        const rect = el.getBoundingClientRect();
        tip.style.display = 'block';

        const tw   = tip.offsetWidth;
        const th   = tip.offsetHeight;
        const left = Math.max( 8, Math.min( rect.left + rect.width / 2 - tw / 2, window.innerWidth - tw - 8 ) );

        let top = rect.top - th - 8;
        if( top < 8 )
            top = rect.bottom + 8;

        tip.style.left    = left + 'px';
        tip.style.top     = top + 'px';
        tip.style.opacity = '1';
    }

    function hide() {
        tip.style.opacity = '0';
        tip.style.display = 'none';
    }

    document.addEventListener( 'mouseover', ( e ) => {
        const icon = e.target.closest && e.target.closest('.spotlight .i, .spotlight-spons .i');
        if( icon )
            show( icon );
    } );

    document.addEventListener( 'mouseout', ( e ) => {
        const icon = e.target.closest && e.target.closest('.spotlight .i, .spotlight-spons .i');
        if( icon )
            hide();
    } );
}